import { useClient, useItemContext, useQuery } from '@weenat/client'
import { isVirtualWeatherStation } from '@weenat/client/dist/core/devices'
import { AllowedMetricsInHistory } from '@weenat/client/dist/core/history/history'
import { useIntl } from '@weenat/wintl'
import DumbMetricSummaryCondensed from 'app/src/dashboard/components/common/summary/dailyWeather/DumbMetricSummaryCondensed'
import { useIsAppAccessRestricted } from 'app/src/hooks/useIsAppAccessRestricted'
import { isNil } from 'lodash-es'
import Card from '../Card'
import Icons from '../Icons'
import Text from '../Text'
import MetricIcons from '../icons/MetricIcons'
import LoadingCircle from '../loaders/LoadingCircle'

interface LatestValueCardProps {
  metric: AllowedMetricsInHistory
}

const LatestValueCard: FC<LatestValueCardProps> = ({ metric }) => {
  const { t } = useIntl()
  const MetricIcon = MetricIcons[metric]

  const { id } = useItemContext()
  const client = useClient()
  const deviceRequest = useQuery(client.devices.get(id), { enabled: !isNil(id) })
  const device = deviceRequest.data

  const deviceSummaryRequest = useQuery(
    client.measurements.devices.summaries.getOne({ deviceId: id })
  )
  const summary = deviceSummaryRequest.data?.data

  const { isRestricted } = useIsAppAccessRestricted({
    isVWS: !isNil(device) && isVirtualWeatherStation(device)
  })

  return metric === 'LW_D' ? null : (
    <Card $p={0}>
      <Flex $p={'md'} $alignItems='center' $gap='md'>
        <MetricIcon $size='lg' $color={`metrics.${metric}.500`} />
        <Text $flexed $fontWeight='medium' $ellipsis>
          {t(`metrics.${metric}${metric === 'FF' ? '_abbr' : ''}` as 'metrics.T', {
            capitalize: true
          })}
        </Text>
      </Flex>
      {!isRestricted ? (
        <>
          {isNil(device) || isNil(summary) ? (
            <Flex $p='md' $flex={1} $justifyContent='center' $alignItems='center'>
              <LoadingCircle size='xl' color='grayscale.black' />
            </Flex>
          ) : (
            <DumbMetricSummaryCondensed metric={metric as 'T'} summary={summary} />
          )}
        </>
      ) : (
        <Flex $flex={1} $p='md'>
          <Flex
            $flex={1}
            $backgroundColor={'grayscale.black'}
            $alignItems='center'
            $justifyContent='center'
            $borderRadius={'md'}
            $flexDirection='column'
            $gap='sm'
            $p='md'
          >
            <Icons.Lock $size='lg' $color={'grayscale.white'} />
            <Text $color='grayscale.white' $fontSize='sm' $textAlign='center'>
              {t('ecommerce.plans.restrictions.carousel_value_downgrade_title')}
            </Text>
          </Flex>
        </Flex>
      )}
    </Card>
  )
}

export default LatestValueCard
